import { type ReactNode, useEffect, useState } from "react";
import { Button, Space } from "@arco-design/web-react";
import { LockKeyhole, Printer } from "lucide-react";
import { useLocation, useOutletContext, useParams, useSearchParams } from "react-router-dom";

import { OrderHandoverDetailFeaturePage, buildOrderHandoverRouteContext, readOrderHandoverRosterReturnState } from "..";
import type { OrderHandoverRosterViewState } from "..";

type AdminOutletContext = {
  setHeaderActions?: (actions: ReactNode) => void;
};

/** 订单交接详情页路由入口。 */
export function OrderHandoverDetailPage() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const outletContext = useOutletContext<AdminOutletContext | undefined>();
  const [isDemoLocked, setIsDemoLocked] = useState(false);
  const context = buildOrderHandoverRouteContext(projectId, searchParams);
  const searchText = searchParams.toString();
  const rosterReturnState = readOrderHandoverRosterReturnState(location.state, context.projectId);

  /** 新标签打开成员详情，当前名单的筛选、分页和位置保持原样。 */
  function openMemberFeeAdjustment(memberId: string, rosterId: string, view: OrderHandoverRosterViewState) {
    const query = new URLSearchParams(searchParams);
    query.set("customerQuoteId", view.customerQuoteId);
    const url = `/crm/order-handover/${encodeURIComponent(context.projectId)}/rosters/${encodeURIComponent(rosterId)}/members/${encodeURIComponent(memberId)}/fee-adjustments?${query.toString()}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  /** 打开独立的出行名单导入工作台。 */
  function openRosterImportPage() {
    const importUrl = `/crm/order-handover/${context.projectId}/roster/import${searchText ? `?${searchText}` : ""}`;
    window.open(importUrl, "_blank", "noopener,noreferrer");
  }

  useEffect(() => {
    outletContext?.setHeaderActions?.(
      <Space size={10}>
        <Button
          type="secondary"
          icon={<LockKeyhole size={16} />}
          aria-pressed={isDemoLocked}
          onClick={() => setIsDemoLocked((current) => !current)}
        >
          演示：切换锁定状态
        </Button>
        <Button icon={<Printer size={16} />} onClick={() => window.print()}>
          打印完整交接表
        </Button>
      </Space>,
    );

    return () => {
      outletContext?.setHeaderActions?.(null);
    };
  }, [isDemoLocked, outletContext]);

  return <OrderHandoverDetailFeaturePage context={context} onOpenRosterImport={openRosterImportPage} onOpenMemberFeeAdjustment={openMemberFeeAdjustment} rosterReturnState={rosterReturnState} />;
}
